const VerificationStatus = {
  QUEUED: 'queued',
  READING: 'reading',
  HASHED: 'hashed',
  VERIFYING: 'verifying',
  ERROR: 'error',
  VALID: 'valid',
  INVALID: 'invalid',
  INVALIDATED: 'invalidated'
};
module.exports = VerificationStatus;
